import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { useAdminApi, selectCls, cardCls } from "./useAdminApi";
import { errMsg } from "@/lib/api";

const ROLE_LABELS = { admin: "Doctor (admin)", reception: "Reception", pending: "No access (pending)" };

export const StaffPanel = ({ me }) => {
  const call = useAdminApi();
  const [data, setData] = useState(null);
  const load = useCallback(() => call("get", "/users").then(setData), [call]);
  useEffect(() => { load(); }, [load]);
  const change = async (u, role) => {
    try { await call("patch", `/users/${u.user_id}/role`, { role }); toast.success("Access updated"); load(); }
    catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className={`${cardCls} mt-4`} data-testid="staff-panel">
      <h3 className="text-xl font-semibold">Staff access</h3>
      <p className="text-sm text-ink-muted mt-1">New staff sign up at /admin with their own email and password, then appear here. Give reception staff the Reception role.</p>
      <ul className="divide-y divide-slate-100 mt-4">
        {data?.users.map((u) => (
          <li key={u.user_id} className="py-3 flex flex-wrap items-center justify-between gap-3" data-testid={`staff-row-${u.email}`}>
            <div className="min-w-0"><p className="font-medium text-sm truncate">{u.name || u.email}</p><p className="text-xs text-ink-muted truncate">{u.email}{u.user_id === me.user_id && " · you"}</p></div>
            <select value={u.role} onChange={(e) => change(u, e.target.value)} className={selectCls} data-testid={`staff-role-${u.email}`}>
              {data.roles.map((r) => <option key={r} value={r}>{ROLE_LABELS[r] || r}</option>)}
            </select>
          </li>
        ))}
      </ul>
    </div>
  );
};
